export default {
  ALLOWEDROUTES: [
    '/customer-area/financial',
    '/customer-area/plans-and-contracts',
    '/settings/organizations',
  ],
}
